<ng-container [ngSwitch]="declarationType">
    <ng-container *ngSwitchCase="'padding'">
        <div class="preset-options" [ngClass]="property == 'padding' ? 'presets' : 'slider'">
            <div class="popover-header">{{title}}</div>

            <ng-container *ngIf="property == 'padding';else slider">
                <div class="options-container">
                    <div class="options">
                        <div *ngFor="let paddingClass of paddingClasses" class="option-wrap">
                            <div class="preset-option">
                                <div [ngClass]="[paddingClass.class,'option',paddingClass.class,paddingClass.class == selectedPaddingClass ? 'selected': 'unselected']" (click)="onPaddingSelect(paddingClass)">
                                    <span class="text-highlight">Lorem</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="'margin'">
        <div class="preset-options" [ngClass]="property == 'margin' ? 'presets' : 'slider'">
            <div class="popover-header">{{title}}</div>
        
            <ng-container *ngIf="property == 'margin';else slider">
                <div class="options-container">
                    <div class="options">
                        <div *ngFor="let paddingClass of paddingClasses" class="option-wrap">
                            <div class="preset-option">
                                <div [ngClass]="[paddingClass.class,'option',paddingClass.class,paddingClass.class == selectedPaddingClass ? 'selected': 'unselected']" (click)="onPaddingSelect(paddingClass)">
                                    <span class="text-highlight">Lorem</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <!-- <ng-template #otherMargin>
                <div class="custom-slider">
                    <ngx-slider
                        [(value)]="value"
                        [options]="options"
                        (userChangeStart)="onUserChangeStart($event)"
                        (userChange)="onUserChange($event)"
                        (userChangeEnd)="onUserChangeEnd($event)">
                    </ngx-slider>
                </div>
            </ng-template> -->
            
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="'border'">
        <div class="preset-options" [ngClass]="property == 'border' ? 'presets' : 'slider'">
            <div class="popover-header">{{title}}</div>
            <ng-container *ngIf="property == 'border';else slider">
                <div class="options-container">
                    <div class="options">
                        <div *ngFor="let paddingClass of paddingClasses" class="option-wrap">
                            <div class="preset-option">
                                <div [ngClass]="[paddingClass.class,'option',paddingClass.class,paddingClass.class == selectedPaddingClass ? 'selected': 'unselected']" (click)="onPaddingSelect(paddingClass)">
                                    <span class="text-highlight">Lorem</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <!-- <ng-template #otherBorder>
                <div class="custom-slider">
                    <ngx-slider
                        [(value)]="value"
                        [options]="options"
                        (userChangeStart)="onUserChangeStart($event)"
                        (userChange)="onUserChange($event)"
                        (userChangeEnd)="onUserChangeEnd($event)">
                    </ngx-slider>
                </div>
            </ng-template> -->
            
        </div>
    </ng-container>
</ng-container>
<ng-template #slider>
    <div class="custom-slider">
        <ngx-slider
            [(value)]="value"
            [options]="options"
            (userChangeStart)="onUserChangeStart($event)"
            (userChange)="onUserChange($event)"
            (userChangeEnd)="onUserChangeEnd($event)">
        </ngx-slider>
    </div>
</ng-template>
<div class="popover-wrapper">
    <div class="popover-header">{{title}}</div>
    <div class="layout-container">
        <kve-padding-input [paddingString]="paddingString" (paddingChange)="onPaddingChange($event)"></kve-padding-input>        
    </div>
</div>

